import ShareModal from "../components/modal/ShareModal";
import AlertModal from "../components/modal/AlertModal";


export default {
    components: {ShareModal, AlertModal},

    data() {
        return {
            shareModalShow: false,
            linkCopySuccessAlertShow: false,
            linkCopyErrorAlertShow:false
        }
    },
    methods: {
        bandShare(body) {
            this.shareModalShow = false
            const url = location.href


            window.open(`https://band.us/plugin/share?body=${encodeURIComponent(body + '\n' + url)}&route=${encodeURIComponent(url)}`)



        },
        kakaoShare(title, description, imageUrl) {
            this.shareModalShow = false
            const _this = this
            Kakao.Link.sendDefault({
                objectType: 'feed',
                content: {
                    title: title,
                    description: description,
                    imageUrl: imageUrl,
                    link: {
                        mobileWebUrl: location.href,
                        androidExecParams: 'test',
                    },
                },
                buttons: [
                    {
                        title: '웹으로 이동',
                        link: {
                            mobileWebUrl: location.href,
                        },
                    }
                ]
            });
        },
        kakaoStoryShare(text){
            const _this = this
            Kakao.Story.share({
                url: location.href,
                text: text
            });
        },
        facebookShare(){
            const url = location.href
            window.open(`http://www.facebook.com/sharer.php?u=${url}`);

        },
        copyLink(){
            const url = location.href
            const _this = this
            this.$copyText(url).then(() => {
                _this.linkCopySuccessAlertShow = true
            }).catch(() => {
                _this.linkCopyErrorAlertShow = true
            })
        }
    },
    created() {
        if (!Kakao.isInitialized()) {
            Kakao.init('46b326e2a6127fe5604b2bdbd480e5dc');
            Kakao.isInitialized();
        }
    }
}
